import { FilterTypeEnum } from '@modules/filters/enums';

export function checkFilterTypeHasFloor(filterType: FilterTypeEnum): boolean {
  return [FilterTypeEnum.FloorUtilization, FilterTypeEnum.AreaUtilization].includes(filterType);
}

export function checkFilterTypeHasArea(filterType: FilterTypeEnum): boolean {
  return [FilterTypeEnum.AreaUtilization].includes(filterType);
}
